<template>
    <Card container-class="p-0 card shadow-sm">
      <template #cardHeader>
        <div class="card-header">
          <h2 class="card-title fw-bolder" style="width: 80%;">
            <div class="d-flex flex-start align-items-center flex-equal fw-row w-100 me-4" :title="$t('events.forms.nameUpdating')">
              <span class="fs-2 fw-bolder text-gray-800">{{$t("events.forms.name")}}</span>
              <input type="text" class="form-control form-control-flush fw-bolder text-muted fs-3 w-100" v-model="form.name" >
            </div>
          </h2>
          <div class="card-toolbar">
            <button class="btn btn-flex btn-success me-2" @click="goToPreview">
              {{$t('events.forms.preview')}}
            </button>
            <button  @click="addStep" class="btn btn-flex btn-primary" >
              {{$t('events.forms.add_step')}}
            </button>
          </div>
        </div>
      </template>
      <template #cardBody>
        <div class="accordion accordion-icon-toggle" id="kt_accordion_2">
          <div class="p-5">
            <Sortable id="eventQuiz" :is-table="false" @change="handleChangeOrder">
              <Card v-for="(subform, index) in form.steps" :key="subform.name+index" container-class="draggable p-0 card shadow-sm mb-5">
                <div class="m-5 draggable-handle">
                  <div class="d-flex align-items-center justify-content-between ">
                    <div class="accordion-header py-3 d-flex" data-bs-toggle="collapse" :data-bs-target="'#kt_accordion_2_item_'+index">
                      <span class="accordion-icon">
                        <span class="svg-icon svg-icon-4">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="currentColor"></rect>
                            <path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="currentColor"></path>
                          </svg>
                        </span>
                      </span>
                      <h3 class="fs-4 fw-bold mb-0 ms-4">{{ subform.name }} <span class="text-primary">({{subform.fields?.length}})</span> </h3>
                    </div>
                    <div class="d-flex align-items-center">
                      <button @click="editStep(index)" class="btn btn-sm btn-icon btn-light me-3">
                        <i class="bi bi-pencil-square"></i>
                      </button>
                      <button v-if="subform.can_delete" @click="removeStep(index)" class="btn btn-sm btn-icon btn-light me-3">
                        <i class="bi bi-trash"></i>
                      </button>
                      <button @click="addField(index)" class="btn btn-sm btn-flex btn-primary " >
                        {{$t('events.forms.add_field')}}
                      </button>
                    </div>
      
                  </div>
                  <div :id="'kt_accordion_2_item_'+index" class="fs-6 collapse ps-10" data-bs-parent="#kt_accordion_2">
                    <div class="separator my-5"/>
                    <Card class="p-0 card shadow-sm mb-5" v-for="(field, ind) in subform.fields" :key="ind">
                      <div class="table-responsive mx-4">
                        <table class="table table-row-gray-200 align-middle mb-0 gs-0">
                          <thead>
                          <tr class="border-0">
                            <th class="p-0 w-250px"></th>
                            <th class="p-0 w-200px"></th>
                            <th class="p-0 w-80px"></th>
                            <th class="p-0 w-80px"></th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                            <td>
                              <a href="#" class="text-primary mb-1 fs-6">{{$t('events.forms.table.name')}}</a>
                              <span class="text-muted d-block">{{ field.label }}</span>
                            </td>
                            <td>
                              <a href="#" class="text-primary mb-1 fs-6">{{$t('events.forms.table.type')}}</a>
                              <span class="text-muted d-block">{{ getTypeLocalName(field.type) }}</span>
                            </td>
                            <td class="text-end">
                              <span v-if="field.required" class="badge badge-danger">{{$t('events.forms.table.required')}}</span>
                              <span v-else class="badge badge-warning">{{$t('events.forms.table.not_required')}}</span>
                            </td>
                            <td class="text-end">
                              <button @click="editField(index, ind)" class="btn btn-sm btn-icon btn-light me-3">
                                <i class="bi bi-pencil-square"></i>
                              </button>
                              <button v-if="field.can_delete" @click="removeField(index, ind)" class="btn btn-sm btn-icon btn-light">
                                <i class="bi bi-trash"></i>
                              </button>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </Card> 
                  </div>
                </div>
              </Card>
            </Sortable>
          </div>
          <Card class="card h-100 p-5">
            <CKEditor
                labelClass="form-label fs-6 text-black"
                :label="$t('events.forms.infos')"
                id="forms-editor"
                :content="form.note"
                @text="getNote"
            />
          </Card>
        </div>
      </template>
      <template #cardFooter> 

        <div class="d-flex justify-content-end">
          <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="initForm"></Button>
          <Button v-if="canSubmit" btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="loading" @click="handleFormSubmit"></Button>
        </div>
      </template>
    </Card>
    <StepFormModal id="new_step" :form="stepForm" :steps="stepsOrder" @save="handleStepFormChange"/>
    <FieldFormModal id="new_field" :form="fieldForm" @save="handleFieldFormChange"/>
  </template>
  <script setup>
  
  import {useStore} from "vuex";
  import {useRoute, useRouter} from "vue-router";
  import {computed, nextTick, onMounted, ref, watch} from "vue";
  import Button from "@/components/Button.vue";
  import Card from "@/components/Card.vue";
  import { useSwal } from "@/composables/useSwal";
  import { useLocales } from "@/composables/locales";
  import StepFormModal from "@/components/Form/StepFormModal.vue";
  import FieldFormModal from "@/components/Form/FieldFormModal.vue";
  import Sortable from "@/components/Sortable.vue";
  import CKEditor from "@/components/CKEditor.vue";

  const props = defineProps({
    submitForm: {type: Function, required: true},
    defaultForm: {type: Array, default: []},
    loading: {type: Boolean, default: false},
    canSubmit: {type: Boolean, default: true},
    getting: {type: Boolean, default: false},
    note: {type: String, default: ''}
  })
  
  const store = useStore()
  const router = useRouter()
  const route = useRoute()
  const {showSwal} = useSwal()
  const {locale} = useLocales()
  
  const stepForm = ref({
    name: "",
    description: "",
    repeatable: false,
    order: 0,
    fields: [],
    can_delete: true,
  })
  
  const fieldForm = ref({ 
    type: "",
    label: "",
    name: "",
    placeholder: "",
    required: true,
    options: [],
    extensions: [],
    repeatable: false,
    can_delete: true,
  })
  
  const form = ref({name: '', steps: [], note: ""})
  
  const activeStep = ref(0)
  const activeField = ref(0)
  
  const types = computed(() => store.getters['nps/types'])
  const stepsOrder = computed(() => {
    let steps = []
    form.value.steps.map(el => {
      steps.push({
        name: el.name,
        order: el.order
      })
    })
  
    return steps
  })
  
  watch(() => props.defaultForm, (value) => {
    if(value) {
     initForm()
    }
  }, {deep: true})

  watch(() => props.note, (value) => {
    if(props.note) {
     form.value.note = value
    }
  })
  
  function getTypeLocalName(value){
    let name = value
    let type = types.value.filter(el => el.value == value)
  
    if(type?.length>0){
      name = type[0][locale.value]
    }
    return name
  }
  
  function addStep(){
    activeStep.value = form.value.steps?.length

    stepForm.value = {
      name: "",
      description: "",
      repeatable: false,
      order: form.value.steps.length,
      fields: [],
      can_delete: true
    }
  
    nextTick(() => {
      $('#new_step').modal('toggle');
    });
  }
  
  function editStep(stepIndex){
    activeStep.value = stepIndex
    stepForm.value = JSON.parse(JSON.stringify(form.value.steps[stepIndex]))
      
    nextTick(() => {
      $('#new_step').modal('toggle');
    });
  }
  
  function removeStep(stepIndex){
    showSwal(
        i18n.global.t('alert.remove_step') ,
        i18n.global.t('alert.remove_step_text'),
        'error'
    ).then( async (result) => {
      if (result.value) {
        if (stepIndex > -1 && stepIndex <= form.value.steps.length) {
          let data = form.value.steps
          data.splice(stepIndex, 1)
          data.forEach((item, index) => {
            item.order = index + 1;
          });
          activeStep.value = 0
          form.value.steps = data;
  
          await nextTick(() => {
            handleFormSubmit(false)
          })
        }
      }
   })
  }
  
  
  function addField(stepIndex){
    activeStep.value = stepIndex
    activeField.value = form.value.steps[stepIndex].fields?.length
  
    fieldForm.value = {
      type: "",
      label: "",
      name: "",
      placeholder: "",
      required: true,
      options: [],
      extensions: [],
      repeatable: false,
      can_delete: true,
    }
  
    nextTick(() => {
      $('#new_field').modal('toggle')
    });
  }
  
  function editField(stepIndex, fieldIndex){
    activeStep.value = stepIndex
    activeField.value = fieldIndex
    fieldForm.value = JSON.parse(JSON.stringify(form.value.steps[activeStep.value].fields[fieldIndex]))
  
    nextTick(() => {
      $('#new_field').modal('toggle')
    });
  }
  
  function removeField(stepIndex, fieldIndex){
    showSwal(
        i18n.global.t('alert.remove_field') ,
        i18n.global.t('alert.remove_field_text'),
        'error'
    ).then( async (result) => {
      if (result.value) {
        if (stepIndex > -1 && stepIndex <= form.value.steps.length) {
          if (stepIndex > -1 && fieldIndex <= form.value.steps[stepIndex].fields.length) {
            let data = form.value.steps[stepIndex].fields
            data.splice(fieldIndex, 1)
            activeField.value = 0
            form.value.steps[stepIndex].fields = data
  
            await nextTick(() => {
              handleFormSubmit(false)
            })
          }
        }
      }
    })
  
  
    
  }
  
  function handleFormSubmit(back = true){
    props.submitForm(form.value, back)
  }
  
  function initForm(){
    let data = []
    props.defaultForm.steps.forEach(step => {
      const stepFields = step.fields && Array.isArray(step.fields)
          ? step.fields.filter(field => Object.keys(field).length > 0) // Exclude empty fields
          : [];
  
      if (stepFields.length > 0) {
        data.push({
          name: step.name || '',
          description: step.description || '',
          repeatable: step.repeatable || false,
          can_delete: step.can_delete,
          order: step.order || 0,
          fields: stepFields.map(field => ({
            type: field.type || 'text',
            label: field.label || '',
            name: field.name || '',
            placeholder: field.placeholder || '',
            required: field.required || false,
            options: field.options || [],
            extensions: field.extensions || [],
            repeatable: field.repeatable || false,
            can_delete: field.can_delete
          }))
        });
      }
    });
  
    activeStep.value = 0
    activeField.value = 0
    form.value = {name : props.defaultForm.name, steps:data, note: props.defaultForm.note ?? ''}
  }
  
  function handleStepFormChange(){
    form.value.steps = insertAtPosition(form.value.steps, stepForm.value,activeStep.value)
    
    stepForm.value = {
      name: "",
      description: "",
      repeatable: false,
      order: 0,
      fields: [],
      can_delete: true
    }
  }

  function insertAtPosition(array, newObject, position) {
    const updatedArray = [...array];

    if (activeStep.value >= 0 && activeStep.value < updatedArray.length) {
      updatedArray.splice(activeStep.value, 1);
    }

    updatedArray.splice(position, 0, newObject);

    updatedArray.forEach((item, index) => {
      item.order = index + 1;
    });

    return updatedArray;
  }
  
  function handleFieldFormChange(data){
    let fields = form.value.steps[activeStep.value].fields
    fields.splice(activeField.value, 1, data)
    form.value.steps[activeStep.value].fields = fields
    nextTick(() => {
      handleFormSubmit(false)
    })
  }
  
  function goToPreview(){
    router.push({ name: 'events-form-preview', params: {id: route.params.id, form: route.params.form } })
  }

  function handleChangeOrder({ oldIndex, newIndex }) {
  if (oldIndex === newIndex) return;
    const itemToMove = form.value.steps[oldIndex];
    form.value.steps.splice(oldIndex, 1);
    form.value.steps.splice(newIndex, 0, itemToMove);
    form.value.steps.forEach((item, index) => {
      item.order = index + 1;
    });

    nextTick(() => {
      handleFormSubmit(false)
    })
  }

  function getNote(text) {
    form.value.note = text
  }
  onMounted(() => {
    if(props.note) {
     form.value.note = value
    }
  })
  
 
  
  </script>
  <style scoped>
  .card .card-body{
    padding: 0 !important;
  }
  
  .accordion-item{
    border: 0 !important;
  }
  .accordion-header{
    border-radius: .625rem !important;
  }
  
  .accordion-button{
    border-radius: .625rem !important;
  }
  </style>